<script>
import {
  coursesExpressProductListEmits,
  coursesExpressProductListProps,
  useCoursesExpressProductList
} from "./mixin";
import ProductCategory from "@/components/organisms/product-category";
import FormCheckbox from "@/components/molecules/form-checkbox";
import StickyFooter from "@/components/molecules/sticky-footer";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import ItemContainer from "@/containers/panier/item";
import ProductListItemGrid from "@/components/organisms/product-list/product-list-item-grid/mobile";

export default {
  name: "CoursesExpressProductListMobile",
  components: {
    FormCheckbox,
    StickyFooter,
    Button,
    ProductCategory,
    Card,
    FormSelect,
    FormSelectOption,
    ItemContainer
  },
  props: {
    ...coursesExpressProductListProps()
  },
  emits: ["addToCart", ...coursesExpressProductListEmits()],
  data() {
    return {
      selectedMode: "addToCart"
    };
  },
  methods: {
    actionClicked() {
      this.$emit(this.selectedMode, this.selectedProducts);
    }
  },
  setup(props, context) {
    const {
      itemsBySections,
      sectionIndisponible,
      totalItems,
      toggleSelectProduct,
      isSelected,
      selectAll,
      unselectAll,
      deleteItem,
      selectedProducts
    } = useCoursesExpressProductList(props, context);

    return {
      itemsBySections,
      sectionIndisponible,
      totalItems,
      toggleSelectProduct,
      isSelected,
      selectAll,
      unselectAll,
      deleteItem,
      selectedProducts,
      ProductListItemGrid
    };
  }
};
</script>

<template>
  <div
    id="prd-list"
    class="c-courses-express-product-list-mobile"
  >
    <Card
      variant="grey-11"
      class="u-pt-md u-pb-md u-pl-sm u-pr-sm"
    >
      <ProductCategory
        v-for="section in itemsBySections"
        :key="section.valeur"
      >
        <template #title>
          <span class="u-font-19">
            {{ section.libelle }}
            <span class="u-font-15">({{ section.articles.length }} {{ pluralize(section.articles.length, 'produit') }})</span>
          </span>
        </template>
        <li
          v-for="(item,index) in section.articles"
          :id="`prd-list-${item.attributes.produit.data.id}`"
          :key="item.id"
          class="u-mt-sm"
        >
          <Card
            class="c-courses-express-product-list-mobile__item u-mb-md"
            :variant="isSelected(item.id) ? 'primary-lighter' : 'white'"
          >
            <FormCheckbox
              :value="isSelected(item.id)"
              class="u-p-sm"
              @change="toggleSelectProduct($event, item)"
            >
              <span class="u-font-14 u-inline-block u-pt-xxs">
                <template v-if="isSelected(item.id)">Désélectionner </template>
                <template v-else>Sélectionner</template>
                ce produit
              </span>
            </FormCheckbox>

            <ItemContainer
              :cart-context="cartContext"
              :component="ProductListItemGrid"
              :can-delete="canDelete"
              :index="index"
              :article="item.attributes.produit.data"
              @delete="deleteItem(item)"
            />
          </Card>
        </li>
      </ProductCategory>

      <ProductCategory v-if="sectionIndisponible.length > 0">
        <template #title>
          <span class="u-font-19">
            Indisponibles <span class="u-font-15">({{ sectionIndisponible.length }} {{ pluralize(sectionIndisponible.length, 'produit') }})</span>
          </span>
        </template>
        <li
          v-for="(item,index) in sectionIndisponible"
          :key="item.id"
          class="u-mt-sm"
        >
          <Card
            class="c-courses-express-product-list-mobile__item u-mb-md"
            :variant="isSelected(item.id) ? 'primary-lighter' : 'white'"
          >
            <FormCheckbox
              :value="isSelected(item.id)"
              class="u-p-sm"
              @change="toggleSelectProduct($event, item)"
            >
              <span class="u-font-14 u-inline-block u-pt-xxs">
                <template v-if="isSelected(item.id)">Désélectionner </template>
                <template v-else>Sélectionner</template>
                ce produit
              </span>
            </FormCheckbox>

            <ItemContainer
              :component="ProductListItemGrid"
              :can-delete="canDelete"
              :article="item.attributes.produit.data"
              indisponible
              :index="index"
              @delete="deleteItem(item)"
            />
          </Card>
        </li>
      </ProductCategory>
    </Card>

    <StickyFooter v-if="selectedProducts.length > 0">
      <div class="u-pl-lg u-pr-md u-text-center">
        <template v-if="selectedProducts.length === totalItems">
          <Button
            link
            variant="text-light"
            class="u-mb-sm"
            @click="unselectAll"
          >
            Tout désélectionner
          </Button>
        </template>
        <template v-else>
          <Button
            link
            variant="text-light"
            class="u-mb-sm"
            @click="selectAll"
          >
            Tout sélectionner
          </Button>
        </template>
        <div
          v-if="!canDelete"
          class="u-text-center"
        >
          <Button
            variant="secondary"
            radius="full"
            size="md"
            @click="$emit('addToCart', selectedProducts)"
          >
            Ajouter les produits au panier
          </Button>
        </div>
        <div
          v-else
          class="u-flex u-mt-sm"
        >
          <FormSelect
            v-model="selectedMode"
            title="Action"
          >
            <FormSelectOption value="addToCart">
              Ajouter au panier les produits sélectionnés
            </FormSelectOption>
            <FormSelectOption value="delete">
              Supprimer les produits sélectionnés
            </FormSelectOption>
          </FormSelect>
          <Button
            variant="primary"
            radius="full"
            size="md"
            class="u-ml-sm"
            @click="actionClicked()"
          >
            OK
          </Button>
        </div>
      </div>
    </StickyFooter>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/courses-express-product-list-mobile.scss";
</style>
